export default __webpack_public_path__ + "static/media/flow.92c1e4f2.svg";